const ACTION_TYPE = {
    INIT_AUTH: "INIT_AUTH",
    RESET_AUTH: "RESET_AUTH",
  };
  
  export { ACTION_TYPE };